<div style="background-color: #fbd364">
	<div class="custom-style">
		<div class="outer-div">
			<div class="inner-div">
				<h1 class="heading1">GET REAL INSIGHTS</h1>
				<h1 class="heading2">
					ANYWHERE, ANYTIME,
					<br />
					FROM&nbsp;ANYONE
					<br />
				</h1>
				<p class="heading3">Jotto makes it easy to understand your</p>
				<div class="typing-container">
					<h1 class="heading4">{{ displayText }}</h1>
					<span class="cursor"></span>
				</div>
			</div>
		</div>
	</div>
</div>
